import * as React from 'react'

export const IconHeart = () => (
  <svg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M11.8 5.214a5.674 5.674 0 0 0-8.126 0c-2.232 2.274-2.232 5.954 0 8.228l6.185 6.303a3 3 0 0 0 4.282 0l6.185-6.303c2.232-2.274 2.232-5.954 0-8.228a5.674 5.674 0 0 0-8.126 0l-.2.203-.2-.203Z'
      fill='currentColor'
    />
    <path d='M19 9.5a3 3 0 0 0-3-3' stroke='#EEE6EF' strokeWidth='2' strokeLinecap='round' />
  </svg>
)
